// widget-worker.js

// Основная функция, которую будем вызывать вручную
async function sendWidgetConfig(workerUrl, widgetConfig, shopifyCustomerId, skript) {
  const payload = { shopifyId: shopifyCustomerId, content: widgetConfig };
  console.log("📤 Отправка на воркер:", workerUrl, payload);
  try {
    const res = await fetch(workerUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      mode: "cors",
      body: JSON.stringify(payload)
    });

    const text = await res.text();
    let data;
    try {
      data = JSON.parse(text);
    } catch (e) {
      data = { success: false, error: "Не удалось распарсить JSON", raw: text };
    }
    //console.log("✅ Ответ от воркера:", data);
    alert(`✅ Запись успешна!\nПуть: ${skript}`);
    return data;
  } catch (err) {
    //console.error("⚠️ Ошибка сети:", err);
    return { success: false, error: err.message };
  }
}

// Экспортируем глобально, чтобы была доступна на странице
window.sendWidgetConfig = sendWidgetConfig;
